// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2QgBu","info":"UpdateTermsInfo_info__3_k5P"};